// ─────────────────────────────────────────────────────────────
// Mount this inside App.jsx (or main.jsx) — it auto-tracks:
//   - Every route change as a GA4 page_view
//   - Conversion events on auth and purchase actions
//
// Usage in App.jsx:
//   import AnalyticsProvider from "./components/AnalyticsProvider";
//   <AnalyticsProvider>
//     <RouterProvider router={router} />  (or your <Routes>)
//   </AnalyticsProvider>
// ─────────────────────────────────────────────────────────────

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ── Route → page title map ────────────────────────────────────
const PAGE_TITLES = {
  "/":                 "Home",
  "/home":             "Home",
  "/bills":            "Pay Bills",
  "/bills/airtime":    "Buy Airtime",
  "/bills/data":       "Buy Data",
  "/bills/electricity":"Pay Electricity",
  "/bills/tv":         "Pay Cable TV",
  "/rewards":          "Rewards",
  "/wallet":           "My Wallet",
  "/deposit-fiat":     "Fund Wallet",
  "/withdraw":         "Withdraw Funds",
  "/auth":             "Sign In / Sign Up",
  "/profile":          "Profile",
};

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const path  = location.pathname;
    const title = PAGE_TITLES[path] || document.title;

    // GA4 page_view via gtag
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path:     path,
        page_title:    title,
        page_location: window.location.href,
      });
    }

    // GTM dataLayer push
    if (window.dataLayer) {
      window.dataLayer.push({
        event:      "pageView",
        pagePath:   path,
        pageTitle:  title,
      });
    }

    // Update document title for tab clarity
    if (title && title !== document.title) {
      document.title = `${title} — Easwallet`;
    }
  }, [location.pathname]);

  return null;
}

export default function AnalyticsProvider({ children }) {
  return (
    <>
      <RouteTracker />
      {children}
    </>
  );
}
